import React from 'react';
import TextInput from '../TextInput/TextInput.jsx';
import Field from '../Field/Field.jsx';

/**
 * `TextInput` wrapped in a `Field` element.
 * 
 * @property {string}		label					-	User-facing name for the field
 * @property {string}		name					-	HTML name for the form field. Used for 
 * 	the `for` attribute on the label as well.
 * @property {object}		[validation]		-	Validations to apply to field. Either
 * 	a validation object, or an array of validation objects, from the component's
 * 	validation state.
 * 
 * **All properties passed to the `TextInput` component.** See `TextInput` component for more details.
 */
export default class FormInput extends React.Component {

	render() {

		return <Field name={this.props.name} label={this.props.label} validation={this.props.validation}>
			<TextInput {...this.props} />
		</Field>;
	}
}